import { EntityId } from '@reduxjs/toolkit';
import { ribTypeEntityAdapter } from './rib-type.slice';
import { RootState } from '../../../_config/redux';

const ribSelector = ribTypeEntityAdapter.getSelectors<RootState>((state) => state.ribType);

export const selectribTypeById = (id: EntityId) => (state: RootState) => ribSelector.selectById(state, id);

export const selectAllribTypes = (state: RootState) => ribSelector.selectAll(state);